import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // load translation using http -> see /public/locales
    .use(Backend)
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        load: 'languageOnly',
        debug: false,
        // React escapes every value it renders, so i18next's own escaping is
        // redundant here -- and it mangles ordinary text: a farm named
        // "daki 17/08/26" interpolated into a message came out as
        // "daki 17&#x2F;08&#x2F;26". Safe to disable: the monorepo renders no
        // dangerouslySetInnerHTML and uses no <Trans> component.
        interpolation: { escapeValue: false },
        ns: ['translation', 'compliance'],
        defaultNS: 'translation'
    });

// WCAG 3.1.1 Language of Page: index.html ships with lang="en", so without
// this every non-English page is announced by a screen reader in the wrong
// language. Keep the document element in step with the active language.
const syncDocumentLanguage = (language) => {
    if (language) document.documentElement.lang = language.split('-')[0];
};

syncDocumentLanguage(i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;